import { ymapsTypes } from '@/entities';

export const createPlacemark = (coords: number[], ymaps: typeof ymapsTypes, loadingText: string = 'loading..') => {
  if (!ymaps.current) {
    return;
  }

  return new ymaps.current.Placemark(
    coords,
    { iconCaption: loadingText },
    { preset: 'islands#violetDotIconWithCaption', draggable: true },
  );
};
